export const Types = {
    GET_PERSONNEL_SUMMARY: " GET_TASKS_LIST",
    GET_POOL_LIST: " GET_POOL_LIST",
    SET_PERSONNEL_SUMMARY: " SET_TASKS_LIST",
    SET_POOL_LIST: " SET_POOL_LIST",
    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",
};

export const getPersonnelSummary = (payload) => ({
    type: Types.GET_PERSONNEL_SUMMARY,
    payload,
});

export const getList = () => ({
    type: Types.GET_POOL_LIST,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});

export const setPersonnelSummary = (payload) => ({
    type: Types.SET_PERSONNEL_SUMMARY,
    payload,
});

export const setList = (payload) => ({
    type: Types.SET_POOL_LIST,
    payload,
});
